import { useSetRecoilState } from "recoil";

import {
    brokerDataState,
    carDescriptionCatalogValueState,
    carDescriptionDatePurchasedState,
    carDescriptionDateRegistrationState,
    carDescriptionFuelState,
    carDescriptionInvoiceValueState,
    carDescriptionMakeState,
    carDescriptionModelState,
    carDescriptionPowerState,
    carDescriptionVehicleTypeState,
    carDetailsMileageState,
    carDetailsSecurityOptionsState,
    carTypeState,
    driverHistory_AccidentsState,
    driverHistory_InsuranceState,
    driverHistory_LicenseState,
    driverInformationBirthdayState,
    driverInformationCityState,
    driverInformationLetterboxState,
    driverInformationNumberState,
    driverInformationPostalCodeState,
    driverInformationStreetState,
    insuranceChoiceState,
    tariffsState,
    totalPriceState,
    weTakeCareActivated,
    weTakeCareReason,
    weTakeCareStepout,
    yourInformationConsentState,
    yourInformationEmailState,
    yourInformationFirstNameState,
    yourInformationLastNameState,
    yourInformationPhoneState,
    yourInformationQuestionState,
} from "@states";

export function useClearData() {
    const setTariff = useSetRecoilState(tariffsState);

    const setCarType = useSetRecoilState(carTypeState);

    const setCarDescriptionMake = useSetRecoilState(carDescriptionMakeState);

    const setCarDescriptionModel = useSetRecoilState(carDescriptionModelState);

    const setCarDescriptionVehicleType = useSetRecoilState(
        carDescriptionVehicleTypeState,
    );

    const setCarDescriptionFuel = useSetRecoilState(carDescriptionFuelState);

    const setCarDescriptionPower = useSetRecoilState(carDescriptionPowerState);

    const setCarDescriptionCatalogValue = useSetRecoilState(
        carDescriptionCatalogValueState,
    );

    const setCarDescriptionDateRegistration = useSetRecoilState(
        carDescriptionDateRegistrationState,
    );

    const setCarDescriptionDatePurchased = useSetRecoilState(
        carDescriptionDatePurchasedState,
    );

    const setCarDescriptionInvoiceValue = useSetRecoilState(
        carDescriptionInvoiceValueState,
    );

    const setDriverInformationBirthday = useSetRecoilState(
        driverInformationBirthdayState,
    );

    const setDriverInformationCity = useSetRecoilState(
        driverInformationCityState,
    );

    const setDriverInformationLetterbox = useSetRecoilState(
        driverInformationLetterboxState,
    );

    const setDriverInformationPostalCode = useSetRecoilState(
        driverInformationPostalCodeState,
    );

    const setDriverInformationNumber = useSetRecoilState(
        driverInformationNumberState,
    );

    const setDriverInformationStreet = useSetRecoilState(
        driverInformationStreetState,
    );

    const setCarDetailsMileage = useSetRecoilState(carDetailsMileageState);

    const setCarDetailsSecurityOptions = useSetRecoilState(
        carDetailsSecurityOptionsState,
    );

    const setDriverHistoryLicense = useSetRecoilState(
        driverHistory_LicenseState,
    );

    const setDriverHistoryInsurance = useSetRecoilState(
        driverHistory_InsuranceState,
    );

    const setDriverHistoryAccidents = useSetRecoilState(
        driverHistory_AccidentsState,
    );

    const setTotalPrice = useSetRecoilState(totalPriceState);

    const setInsuranceChoice = useSetRecoilState(insuranceChoiceState);

    const setBrokerData = useSetRecoilState(brokerDataState);

    const setYourInformationFirstname = useSetRecoilState(
        yourInformationFirstNameState,
    );
    const setYourInformationLastname = useSetRecoilState(
        yourInformationLastNameState,
    );
    const setYourInformationEmail = useSetRecoilState(
        yourInformationEmailState,
    );
    const setYourInformationPhone = useSetRecoilState(
        yourInformationPhoneState,
    );
    const setYourInformationQuestion = useSetRecoilState(
        yourInformationQuestionState,
    );
    const setYourInformationConsent = useSetRecoilState(
        yourInformationConsentState,
    );

    const setWeTakeCareActivated = useSetRecoilState(weTakeCareActivated);

    const setWeTakeCareStepout = useSetRecoilState(weTakeCareStepout);
    const setWeTakeCareReason = useSetRecoilState(weTakeCareReason);

    const clearAll = () => {
        setTariff(undefined);
        setCarType(undefined);
        setCarDescriptionMake("");
        setCarDescriptionModel("");
        setCarDescriptionVehicleType(undefined);
        setCarDescriptionFuel("");
        setCarDescriptionPower("");
        setCarDescriptionCatalogValue("");
        setCarDescriptionDateRegistration("");
        setCarDescriptionDatePurchased("");
        setCarDescriptionInvoiceValue("");
        setDriverInformationBirthday("");
        setDriverInformationCity(undefined);
        setDriverInformationLetterbox("");
        setDriverInformationPostalCode("");
        setDriverInformationNumber("");
        setDriverInformationStreet(undefined);
        setCarDetailsMileage("0");
        setCarDetailsSecurityOptions([]);
        setDriverHistoryLicense("");
        setDriverHistoryInsurance("");
        setDriverHistoryAccidents("");
        setTotalPrice(0);
        setInsuranceChoice(undefined);
        setBrokerData(undefined);
        setYourInformationFirstname("");
        setYourInformationLastname("");
        setYourInformationEmail("");
        setYourInformationPhone("");
        setYourInformationQuestion("");
        setYourInformationConsent(false);
        setWeTakeCareActivated(false);
        setWeTakeCareStepout(false);
        setWeTakeCareReason(undefined);
    };

    return { clearAll };
}
